import { PriceType } from './price-type';
import { SeatingOptionGroup, SeatingOption } from './seating-option';
import { IExchangeTicket } from './ticket-exchange';

export interface Seat {
    svgPath: string;

    activeSvgPath: string;

    inCartSeatPath: string;

    seatId: string;
    tessituraSeat: SeatInfo;
    suggestedSeat: boolean;

    svgPathId: string;
    seatStyleId: string;
    styleCultureId: string;
    seatingOptionGroup: SeatingOptionGroup;
    seatRank: number; // not used but could be for debugging?

    exchangeHigherPriceSvgPath: string;
    exchangeHigherPriceSeatStyleId: string;
    exchangeSamePriceSvgPath: string;
    exchangeSamePriceSeatStyleId: string;

    inCartSeatStyleId: string;

    zoneDescription: string;

    seatViewImageSrc: string; //added client side
    seatStyle: SeatStyle; //added client side
    seatStyleCulture: SeatStyleCulture;
    originalSeatStyleCulture: SeatStyleCulture;

    satisfiedSeatConditionIds: Array<string>;
    associatedSeatmapId?: string; //added client side
}
export interface CartSeat extends Seat {
    selectedPricing: SeatPricing;
    selectedSeatingOptions: Array<SeatingOption>;
    isGroupedSeat: boolean;
}

export interface SeatZone {
    zoneId: number;
    prices: Array<SeatPricing>;
    description: string;
}

export interface SeatPaths {
    seatId: string;
    availableSeatPath: string;
    unavailableSeatPath: string;
    suggestedSeatPath: string;
    inCartSeatPath: string;
}

export interface SeatStyle {
    brandId: string; //not used
    color: string; //not used
    highlightColor: string; //not used
    icon: string; //not used
    id: string;
    name: string;
    selectedColor: string; //not used

    seatStyleSvgPath: string;
    svgStrokeWidth: number;
    svgStrokeColor: string;
    svgDefaultFill: string;
    svgHoverFill: string;
    svgSelectedFill: string;
    svgViewBox: string;
}

export interface SeatStyleCulture {
    seatStyleId: string;
    legendOrder: number;
    confirmPrompt: string;
    displayName: string;
    fullPrompt: string;
    smallPrompt: string;
    //seatStyle: SeatStyle;
    showOnCollapsedLegend: boolean;
}

export interface SeatPriceQuantity {
    seatPricing: SeatPricing,
    quantity: number
    maxQuantity?: number // needed for GA zones..
    minQuantity?: number // needed for GA zones..
}

export interface SeatPricing {
    priceTypeDescription: string;
    price: number;
    priceCarted: number;
    priceTypeId: number;
    priority: number; // not used
    isDefaultPriceType: boolean, // not used
    defaultPrice: number;// Only relevant to exchanges. The price of the ticket before exchange calculations came into play.
    maxSeats: number; //not used
    zoneDescription: string;
    zoneId: number;
    feeAmount?: number;

    exchangeTicket: IExchangeTicket; //not used
}

export interface SeatPricingWithQuantity extends SeatPricing {
    quantity?: number;
}

export enum AisleIndicator {
    None = 0,
    Left = 1,
    Right = 2,
    Both = 3
}

export interface SeatInfo {
    aisle: AisleIndicator;
    allocationNumber: number; //not used
    circle: Circle; //not used
    displayLetter: string; //not used
    holdCodeId: number; //not used
    isAvailable: boolean;
    logicalSeatNumber: number;
    logicalSeatRow: number; //not used
    numberText: string;
    rowText: string;
    screenId: number; //not used
    seatNumber: number;
    seatType: number;
    sectionDescription: string;
    sectionId: number; //not used
    status: SeatStatus; //not used
    tessituraStatus: SeatStatus; //not used
    zoneId: string;
    zoneDescription: string; //not used
    consecutiveSeatGroupId: number;

    //client side
    isDisabled: boolean;

}

export interface Circle {
    id: string;
    x: number;
    y: number;
}

export enum SeatStatus {
    AVAILABLE = 0,
    HELD_BREAKABLE = 1,
    LOCKED_BY_SESSION = 2,
    LOCKED = 3,
    HELD = 4,
    NOT_IN_ALLOCATION = 5,
    BLACKED_OUT = 6,
    RESERVED_UNPAID = 7,
    RESERVED_PAID = 8,
    NON_SEAT = 9,
    UPDATED_PRODUCT_PAID = 10,
    RESERVED_BY_THIS_CUSTOMER = 11,
    RESERVED_IN_ORDER = 12,
    TICKETED = 13,
    TICKETED_BY_THIS_CUSTOMER = 14,
    TICKETED_IN_ORDER = 15,
    LOCKED_BY_SESSION_RELEASING = 16,
    LOCKED_BY_SESSION_RETURNING = 17,
    DONATED = 18,
    UPGRADE_PRODUCT_UNPAID = 19,
    UPGRADE_PAID = 20,
    UPGRADE_UNPAID = 21,
    ENTERED_HOUSE = 22
}